import React, { useState, useRef, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useRecoilValue, useRecoilState, useResetRecoilState, useSetRecoilState } from 'recoil'
import {
  selectedRooms,
  paymentInfoState,
  userInfoState,
  ratePlanChoice,
  couponState,
  couponSuccessState,
  termsOfServiceState,
  termsOfServiceErrorState,
  iUnderstandState,
  IUnderstandErrorState,
  checkoutCardErrorState
} from 'states/CheckOutStates/atoms';
import { dateRangeState, guestQuantityState, roomQuantityState, isWheelchairAccessibleState, childrenQuantityState } from 'states/SearchBarStates/atoms';
import { addOnOptionsState } from 'states/OptionStates/atoms';
import {
  PaymentSectionContainer,
  PaymentInfoContainer,
  CheckOutContentContainer
} from './style'
import PlanSection from './PlanSection';
import FormInputField from 'components/FormInputField';
import PhoneNumberInput from 'components/PhoneNumberInput';
import BookingSummary from './BookingSummary';
import Modal from 'components/Modal';
import SignInModalBody from './SignInModalBody';
import ReactInputMask from 'react-input-mask'
import { useGoogleAutocomplete } from 'customHooks/useGoogleAutocomplete';
import {
  creditCardMask,
  expireDateMask,
  cvvMask,
  amexCvvMask,
} from './inputMask/inputMasks';
import { useAuth } from 'customHooks/useAuth';
import { usePaymentForm } from 'customHooks/usePaymentForm';
import { useMutation } from '@apollo/client';
import { CREATE_GROUP_BOOKING } from 'graphql/service';
import { detectCardType, isAmexCardNumber } from 'utils/util'
import { GroupTenantBookingInput } from 'types/commonTypes';
import { colors } from 'constants/colors';
import greenCheck from 'assets/icons/green-check-icon-new.svg';
import lockLocked from 'assets/icons/lock-locked.svg';
import nounSearch from 'assets/icons/noun-search.svg';
import nounQuestion from 'assets/icons/noun-question.svg';
import { AttentionYellow } from 'assets/icons';
import { reloadTrips } from 'states/CommonStates/atoms';
import CouponInputBlock from "components/CouponInputBlock";
import { styleSizes, styleSizesNumber } from "constants/styleSizes";
import useWindowSize from "customHooks/useWindowSize";
import TermsOfServiceBlock from "components/TermsOfServiceBlock";
import NoWindowDisclaimerBlock from "components/NoWindowDisclaimerBlock";
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';
import { getReservationCompleteMessage } from 'components/CompleteAlert';
import {
  validateBillingAddress,
  validateBillingAddressField,
} from 'utils/billingAddressValidation';
import CountryProvinceFields from 'components/CountryProvinceFields';
import StyledButton from 'components/Button';

const debug = false;

const normalizePhoneNumber = (value: string) =>
  value.replace(/[^\d+]/g, '');

const isStrictValidPhoneNumber = (value: string) => {
  const cleanedValue = value.replace(/\s/g, '');
  const normalizedValue = normalizePhoneNumber(value);

  return (
    cleanedValue === normalizedValue &&
    /^\+[0-9]{8,14}$/.test(normalizedValue)
  );
};


const CheckOutContent: React.FC = () => {

  // Locale debug 

  //   let country: string | string[] = navigator.language?.split("-")[1];

  //   if (!country) {
  //   const lang = navigator.language?.split("-")[0];

  //   const fallbackMap: Record<string, string | string[]> = {
  //     en: ["us", "ca"],
  //     fr: ["ca", "fr"],
  //     nl: "nl",
  //     ru: "ru",
  //     de: "de",
  //     es: "es",
  //     it: "it",
  //     by: "by"
  //   };

  //   country = fallbackMap[lang] || ["us", "ca"];
  // } else {
  //   country = country.toLowerCase();
  // }


  // const locale = navigator.language;

  // const countryDebug = Array.isArray(country) ? JSON.stringify(country) : country;

  // const debugString = `Country detection by Locale: Locale from browser:"${locale}", Country: "${countryDebug}"`;

  // Locale debug 


  const { showGlobalError, showGlobalMessage } = useGlobalAlerts();

  const history = useHistory()
  const { validToken, userId, refreshUserInfo } = useAuth()
  const [openSignInModal, setOpenSignInModal] = useState(false)

  useEffect(() => {
    if (validToken && userId) {
      refreshUserInfo()
    }
  }, [validToken, userId, refreshUserInfo])

  const persistSelectedRooms = useRecoilValue(selectedRooms)
  const dateRange = useRecoilValue(dateRangeState)

  const { width: windowWidth } = useWindowSize();

  const isTabletLayout =
  windowWidth > parseInt(styleSizes.miniBreakpoint, 10) &&
  windowWidth <= styleSizesNumber.tabletBreakpoint;

  if (debug) {
    console.log("dateRange: ", dateRange);
  }

  const roomQuantity = useRecoilValue(roomQuantityState)
  const guestQuantity = useRecoilValue(guestQuantityState)
  const childrenQuantity = useRecoilValue(childrenQuantityState)
  useRecoilValue(addOnOptionsState)
  //const ratePlanId = useRecoilValue(ratePlanChoice)



  const termsOfServiceChecked = useRecoilValue(termsOfServiceState)
  const [termsOfServiceError, setTermsOfServiceError] = useRecoilState(termsOfServiceErrorState)

  const [iUnderstandChecked, setIUnderstandChecked] = useRecoilState(iUnderstandState)
  const [iUnderstandError, setIUnderstandError] = useRecoilState(IUnderstandErrorState)


  const coupon = useRecoilValue(couponState)

  const couponSuccess = useRecoilValue(couponSuccessState)

  const clearPaymentInfo = useResetRecoilState(paymentInfoState)
  const clearSelectedRooms = useResetRecoilState(selectedRooms)
  const clearRoomQuantity = useResetRecoilState(roomQuantityState)
  const clearGuestQuantity = useResetRecoilState(guestQuantityState)
  const clearDateRange = useResetRecoilState(dateRangeState)
  const clearAddOnOptions = useResetRecoilState(addOnOptionsState)
  const clearIsWheelChairAccessible = useResetRecoilState(isWheelchairAccessibleState)
  const clearRatePlanChoice = useResetRecoilState(ratePlanChoice)
  const clearCouponCode = useResetRecoilState(couponState)
  const clearCouponSuccess = useResetRecoilState(couponSuccessState)

  const [checkoutCardError, setCheckoutCardError] = useRecoilState(checkoutCardErrorState)
  const [userInfo, setUserInfo] = useRecoilState(userInfoState)
  const [emailError, setEmailError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [phoneNumber, setPhoneNumber] = useState(
    userInfo.phoneNumberInput
  )

  const [initialPhoneNumber, setInitialPhoneNumber] = useState(
    userInfo.phoneNumberInput
  )

  const prefilledUserIdRef = useRef<string | null>(null)

  const [phoneNumberValidity, setPhoneNumberValidity] = useState(false)

  const [phoneNumberError, setPhoneNumberError] = useState(false)
  const [ratePlanId] = useRecoilState(ratePlanChoice)


  const [noWindow, setNoWindow] = useState('');

  const [fieldErrorMessages, setFieldErrorMessages] = useState<Record<string, string>>({});

  useEffect(() => {
    let windowMessage = "";

    if (!persistSelectedRooms.hasWindows) {
      windowMessage = "This room does not have a window, if you want a window please press back and modify your booking.";

      if (persistSelectedRooms.name === "Bishop Inside") {
        windowMessage = "This room does not have a window or a skylight, if you want a window please press back and modify your booking.";
      }
    }

    setNoWindow(windowMessage);

  }, [persistSelectedRooms]);

  if (debug) {
    console.log("ratePlanId: ", ratePlanId);
  }
  const isWheelchairAccessible = useRecoilValue(isWheelchairAccessibleState)

  const setReloadTrips = useSetRecoilState(reloadTrips);

  useEffect(() => {
    if (phoneNumberValidity) {
      setPhoneNumberError(false)
      setUserInfo((userInfo) => ({ ...userInfo, phoneNumberInput: phoneNumber }))
    }
  }, [phoneNumber, phoneNumberValidity, setPhoneNumberError, setUserInfo])

  const [paymentInfo, setPaymentInfo] = useRecoilState(paymentInfoState)
  const cardNumberDigits = paymentInfo.creditCardNumber.replace(/\D/g, '')
  const isAmex = isAmexCardNumber(cardNumberDigits)
  const cvvLength = isAmex ? 4 : 3
  const creditCardType = isAmex || cardNumberDigits.length === 16
    ? detectCardType(cardNumberDigits)
    : ''
  const cvvTouchedRef = useRef(false)
  const [addressLine2, setAddressLine2] = useState('')

  const removeSavedInformation = () => {
    clearPaymentInfo()
    clearIsWheelChairAccessible()
    clearSelectedRooms()
    clearRoomQuantity()
    clearGuestQuantity()
    clearDateRange()
    clearAddOnOptions()
    clearRatePlanChoice()
    clearCouponCode()
    clearCouponSuccess()
    localStorage.removeItem('selectedRooms')
    localStorage.removeItem('roomQuantity')
    localStorage.removeItem('guestQuantity')
    localStorage.removeItem('dateRange')
    localStorage.removeItem('addOnOptions')
    localStorage.removeItem('ratePlanId')
    localStorage.removeItem('coupon')
    localStorage.removeItem('isWheelchairAccessible')
    localStorage.removeItem('termsOfServiceChecked')
  }

  const handleCountryChange = (value: string) => {
    clearFieldErrorMessage('COUNTRY');

    setPaymentInfo((prev) => ({
      ...prev,
      country: value,
    }));
  };

  const handleProvinceChange = (value: string) => {
    clearFieldErrorMessage('PROVINCE');

    setPaymentInfo((prev) => ({
      ...prev,
      province: value,
    }));
  };


  const [showIUnderstandCheckbox, setShowIUnderstandCheckbox] = useState(false);

useEffect(() => {
  if (persistSelectedRooms.hasWindows) {
    setIUnderstandError(false);
    setIUnderstandChecked(true);
    setShowIUnderstandCheckbox(false);
  } else {
    setIUnderstandError(false);
    setIUnderstandChecked(false);
    setShowIUnderstandCheckbox(true);
  }
}, [persistSelectedRooms, setIUnderstandError, setIUnderstandChecked]);

  // const getRawErrorMessage = (error: any) => {
  //   return (
  //     error?.graphQLErrors?.[0]?.message ||
  //     error?.message ||
  //     ''
  //   );
  // };

  // const isCardError = (error: any) => {
  //   const msg = getRawErrorMessage(error).toLowerCase();
  //   return msg.includes('card');
  // };

  // const isExpiredCardError = (error: any) => {
  //   const msg = getRawErrorMessage(error).toLowerCase();
  //   return msg.includes('expired');
  // };

  // const getBookingErrorMessage = (error: any) => {
  //   const rawMessage = getRawErrorMessage(error);

  //   if (rawMessage.includes('CARD_NOT_ON_WHITE_LIST')) {
  //     return 'Your card was declined. Please try another card.';
  //   }

  //   if (rawMessage.includes('Elavon transaction failed')) {
  //     return 'Payment failed. Please check your card details and try again.';
  //   }

  //   if (rawMessage && rawMessage.trim().length > 0) {
  //     return rawMessage;
  //   }

  //   return 'Booking failed. Please try again.';
  // };

  const getCardValidationError = (error: any) => {
    const graphQLError = error?.graphQLErrors?.[0];
    const extensions = graphQLError?.extensions || {};

    return {
      message: graphQLError?.message || 'Payment failed. Please try again.',
      code: extensions.code,
      errorCode: extensions.errorCode,
      field: extensions.field,
      validationErrors: extensions.validationErrors || [],
    };
  };

  const clearFieldErrorMessage = (field: string) => {
    setFieldErrorMessages((prev) => ({
      ...prev,
      [field]: '',
    }));
  };


  const applyCardFieldError = (field: string, message: string) => {
    if (field === 'NONE') {
      showGlobalError(message);
      return;
    }

    setFieldErrorMessages((prev) => ({
      ...prev,
      [field]: message,
    }));

    switch (field) {
      case 'CARD_NUMBER':
        setCheckoutCardError(message);
        setPaymentError((prev) => ({
          ...prev,
          creditCardNumberError: true,
        }));
        break;

      case 'EXPIRY':
        setPaymentError((prev) => ({
          ...prev,
          cardExpirationDateError: true,
        }));
        break;

      case 'CVV':
        setPaymentError((prev) => ({
          ...prev,
          cardCVVError: true,
        }));
        break;

      case 'HOLDER_NAME':
        setPaymentError((prev) => ({
          ...prev,
          cardHolderNameError: true,
        }));
        break;

      case 'ADDRESS':
      case 'STREET_ADDRESS':
      case 'CITY':
      case 'PROVINCE':
      case 'ZIPCODE':
      case 'POSTAL_CODE':
      case 'COUNTRY':
        setPaymentError((prev) => ({
          ...prev,
          billingAddressError: true,
        }));
        break;

      case 'NONE':
      default:
        showGlobalError(message);
        break;
    }
  };

  const [createGroupBooking, { loading }] = useMutation(CREATE_GROUP_BOOKING, {
    onCompleted: (createBookingData) => {

      setCheckoutCardError('')

      setFieldErrorMessages({});

      const reservationCode = createBookingData.createGroupBooking?.bookings[0]?.reservationCode
      const originalEmail = userInfo.emailInput
      const resetToken = createBookingData.createGroupBooking?.resetToken
      if (resetToken && originalEmail && reservationCode) {
        removeSavedInformation()
        if (validToken) {
          setReloadTrips(true);
          showGlobalMessage(getReservationCompleteMessage(reservationCode), false, '/account');
          history.push('/account')
        } else {
          history.push('/check-out-confirm', { resetToken, originalEmail, reservationCode })
        }
      } else {
        showGlobalError('Reservation failed. Please try again.')
      }
    },
    onError: (error) => {
      if (debug) {
        console.log('createGroupBooking error:', error);
      }

      setCheckoutCardError('');
      setFieldErrorMessages({});

      const {
        message,
        code,
        field,
        validationErrors,
      } = getCardValidationError(error);

      if (code === 'CARD_VALIDATION_ERROR') {
        if (validationErrors.length > 0) {
          validationErrors.forEach((validationError: any) => {
            applyCardFieldError(
              validationError.field,
              validationError.message || message
            );
          });

          return;
        }

        applyCardFieldError(field, message);
        return;
      }

      showGlobalError(message || 'Booking failed. Please try again.');
    }
  })

  const { isValidatePaymentInfo, paymentError, setPaymentError } = usePaymentForm(creditCardType)
  // const setBillingAddress = (address: string) => {
  //   setPaymentInfo((paymentInfo) => ({...paymentInfo, streetAddress: address}))
  // }

  // const autocompleteRef = useGoogleAutocomplete(setBillingAddress);

  const autocompleteRef = useGoogleAutocomplete(
    (parsedAddress: any) => {
      const addressValidation =
        validateBillingAddress(parsedAddress);

      setPaymentInfo((prev) => ({
        ...prev,
        fullAddress:
          parsedAddress.fullAddress ||
          parsedAddress.streetAddress ||
          '',
        streetAddress:
          parsedAddress.streetAddress || '',
        city: parsedAddress.city || '',
        province: parsedAddress.province || '',
        postalCode: parsedAddress.postalCode || '',
        country: parsedAddress.country || '',
      }));

      // Apartment/suite from the previous address
      // should not remain after selecting a new address.
      setAddressLine2('');

      setPaymentError((prev) => ({
        ...prev,
        billingAddressError:
          !addressValidation.isValid,
      }));

      setFieldErrorMessages((prev) => ({
        ...prev,
        ADDRESS: '',
        STREET_ADDRESS:
          addressValidation.fieldErrors
            .streetAddress || '',
        CITY:
          addressValidation.fieldErrors.city || '',
        PROVINCE:
          addressValidation.fieldErrors.province || '',
        ZIPCODE:
          addressValidation.fieldErrors.postalCode ||
          '',
        POSTAL_CODE: '',
        COUNTRY:
          addressValidation.fieldErrors.country || '',
      }));
    }
  );


  const handleStreetAddressChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;

    clearFieldErrorMessage('ADDRESS');
    clearFieldErrorMessage('STREET_ADDRESS');

    setPaymentInfo((prev) => ({
      ...prev,
      streetAddress: value,
      fullAddress: value,
    }));
  };

  useEffect(() => {
    if (!validToken) {
      prefilledUserIdRef.current = null
      return
    }

    if (
      !userInfo.userId ||
      prefilledUserIdRef.current === userInfo.userId
    ) {
      return
    }

    const streetAddress =
      userInfo.mailAddressInput || '';

    const fullAddress = [
      userInfo.mailAddressInput,
      userInfo.cityInput,
      userInfo.provinceInput,
      userInfo.postalCodeInput,
      userInfo.countryInput,
    ]
      .filter(Boolean)
      .join(', ')

    setPaymentInfo((paymentInfo) => ({
      ...paymentInfo,
      cardHolderName: userInfo.fullNameInput || '',
      fullAddress,
      streetAddress,
      city: userInfo.cityInput || '',
      province: userInfo.provinceInput || '',
      postalCode: userInfo.postalCodeInput || '',
      country: userInfo.countryInput || '',
    }))

    setAddressLine2(userInfo.addressLine2Input || '')

    const profilePhoneNumber = normalizePhoneNumber(
      userInfo.phoneNumberInput || ''
    )

    setPhoneNumber(profilePhoneNumber)
    setInitialPhoneNumber(profilePhoneNumber)
    setPhoneNumberValidity(
      isStrictValidPhoneNumber(profilePhoneNumber)
    )

    prefilledUserIdRef.current = userInfo.userId
  }, [
    validToken,
    userInfo.userId,
    userInfo.fullNameInput,
    userInfo.phoneNumberInput,
    userInfo.mailAddressInput,
    userInfo.addressLine2Input,
    userInfo.cityInput,
    userInfo.provinceInput,
    userInfo.postalCodeInput,
    userInfo.countryInput,
    setPaymentInfo,
  ])

  useEffect(() => {

    if (debug) {
      console.log('paymentInfo:', paymentInfo);
    }

  }, [paymentInfo]);

  const inputRefs = [
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    autocompleteRef
  ]

  const focusNextInput = (currentInputIndex) => {
    const nextInputIndex = currentInputIndex + 1;
    if (nextInputIndex < inputRefs.length) {
      inputRefs[nextInputIndex].current?.focus();
    }
  };
  const onChangeCardHolderName = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {

    clearFieldErrorMessage('HOLDER_NAME');

    setPaymentInfo((paymentInfo) => ({ ...paymentInfo, cardHolderName: e.target.value }))
    if (paymentError.cardHolderNameError) {
      setPaymentError((paymentError) => ({ ...paymentError, cardHolderNameError: false }))
    }
  }

  const onChangeCreditCard = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = e.target.value
    const digits = value.replace(/\D/g, '')
    const nextIsAmex = isAmexCardNumber(digits)
    const nextCardLength = nextIsAmex ? 15 : 16
    const nextCvvLength = nextIsAmex ? 4 : 3
    const type = digits.length === nextCardLength ? detectCardType(digits) : ''

    clearFieldErrorMessage('CARD_NUMBER');

    if (checkoutCardError) {
      setCheckoutCardError('')
    }

    setPaymentInfo((prev) => ({
      ...prev,
      creditCardNumber: value,
      cardCVV: prev.cardCVV.slice(0, nextCvvLength),
    }))
    setPaymentError((prev) => ({
      ...prev,
      creditCardNumberError: digits.length >= nextCardLength && !type,
    }))

    if (nextCvvLength !== cvvLength) {
      clearFieldErrorMessage('CVV');
      setPaymentError((prev) => ({
        ...prev,
        cardCVVError: (cvvTouchedRef.current || prev.cardCVVError) &&
          !new RegExp('^[0-9]{' + nextCvvLength + '}$').test(paymentInfo.cardCVV.slice(0, nextCvvLength)),
      }))
    }

    if (type && cardNumberDigits.length < nextCardLength &&
        digits.startsWith(cardNumberDigits)) {
      focusNextInput(0)
    }
  }

  const onChangeCVV = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, cvvLength)
    if (value === paymentInfo.cardCVV) {
      return
    }
    clearFieldErrorMessage('CVV');

    if (value || paymentInfo.cardCVV) {
      cvvTouchedRef.current = true
    }
    setPaymentInfo((prev) => ({ ...prev, cardCVV: value }))
    if (paymentError.cardCVVError) {
      setPaymentError((prev) => ({ ...prev, cardCVVError: false }))
    }
    if (value.length === cvvLength && paymentInfo.cardCVV.length < cvvLength &&
        value.startsWith(paymentInfo.cardCVV)) {
      focusNextInput(1)
    }
  }

  const onChangeExpireDate = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    clearFieldErrorMessage('EXPIRY');

    setPaymentInfo((paymentInfo) => ({ ...paymentInfo, cardExpirationDate: e.target.value }))
    if (paymentError.cardExpirationDateError) {
      setPaymentError((paymentError) => ({ ...paymentError, cardExpirationDateError: false }))
    }
    if (e.target.value.length === 5) {
      focusNextInput(1)
    }
  }

  const onChangeEmail = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setUserInfo((userInfo) => ({ ...userInfo, emailInput: e.target.value }))
  }

  const handleCheckOut = () => {
    cvvTouchedRef.current = true
    let result = true;

    setCheckoutCardError('');
    setFieldErrorMessages({});

    if (debug) {
      console.log('Starting checkout');
    }

    if (!termsOfServiceChecked) {
      setTermsOfServiceError(true);
      result = false;
    } else if (termsOfServiceError) {
      setTermsOfServiceError(false);
    }

    if (!iUnderstandChecked) {
      setIUnderstandError(true);
      result = false;
    } else if (iUnderstandError) {
      setIUnderstandError(false);
    }

    if (
      !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
        userInfo.emailInput
      )
    ) {
      setEmailError(true);
      result = false;
    } else if (emailError) {
      setEmailError(false);
    }

    const normalizedPhoneNumber = normalizePhoneNumber(phoneNumber);

    if (
      !phoneNumberValidity ||
      !isStrictValidPhoneNumber(phoneNumber)
    ) {
      setPhoneNumberError(true);
      result = false;
    } else {
      setPhoneNumberError(false);

      setUserInfo((userInfo) => ({
        ...userInfo,
        phoneNumberInput: normalizedPhoneNumber,
      }));
    }

    // Validate the regular payment fields first
    const isPaymentInfoValid = isValidatePaymentInfo();

    if (!isPaymentInfoValid) {
      result = false;
    }

    // Then apply the stricter billing address validation,
    // so isValidatePaymentInfo does not overwrite this error
    const addressValidation =
      validateBillingAddress(paymentInfo);

    setPaymentError((prev) => ({
      ...prev,
      billingAddressError: !addressValidation.isValid,
    }));

    setFieldErrorMessages((prev) => ({
      ...prev,
      ADDRESS: '',
      STREET_ADDRESS:
        addressValidation.fieldErrors.streetAddress ||
        '',
      CITY:
        addressValidation.fieldErrors.city || '',
      PROVINCE:
        addressValidation.fieldErrors.province || '',
      ZIPCODE:
        addressValidation.fieldErrors.postalCode || '',
      POSTAL_CODE: '',
      COUNTRY:
        addressValidation.fieldErrors.country || '',
    }));

    if (!addressValidation.isValid) {
      result = false;
    }

    if (!result) {
      if (debug) {
        console.log('Information is not valid!');
      }

      return;
    }

    const groupInput: GroupTenantBookingInput = {
      fullName: paymentInfo.cardHolderName,
      email: userInfo.emailInput,
      phoneNumber: normalizedPhoneNumber,
      checkInDate: new Date(dateRange[0]),
      checkOutDate: new Date(dateRange[1]),
      roomTypeId: persistSelectedRooms.roomTypeId,
      numberOfRooms: roomQuantity,
      numberOfChildren: childrenQuantity,
      numberOfGuests: guestQuantity,
      isWheelchairAccessible,
      ratePlanId,
      billingInfo: {
        cardHolderName: paymentInfo.cardHolderName,
        creditCardNumber:
          paymentInfo.creditCardNumber.replace(/\s/g, ''),
        cardExpirationDate:
          paymentInfo.cardExpirationDate.replace(/[\s/]/g, ''),
        cardCVV: paymentInfo.cardCVV,
        country: paymentInfo.country,
        province: paymentInfo.province,
        streetAddress: [
          paymentInfo.streetAddress?.trim(),
          addressLine2.trim(),
        ]
          .filter(Boolean)
          .join(', '),
        postalCode: paymentInfo.postalCode,
        city: paymentInfo.city,
      },
    };

    if (couponSuccess) {
      groupInput.couponCode = coupon.couponCode;
    }

    if (debug) {
      console.log('groupInput', groupInput);
    }

    createGroupBooking({
      variables: {
        input: groupInput,
      },
    });
  };


  return (
    <CheckOutContentContainer>
      <div className="background"></div>
      <div className="innerContainer">

        {noWindow && (
          <div className="topBookingMessage">
            <div className="noWindow">
              <div className="noWindowIcon"><AttentionYellow /></div>
              <div className="noWindowText">{noWindow}</div>
            </div>
            <div>
            </div>
          </div>
        )}

        <div className="content">
          <PaymentSectionContainer className="checkoutPaymentSection">
            <PlanSection
            />
            {isTabletLayout && (
              <BookingSummary
                handleCheckOut={handleCheckOut}
                loading={loading}
              />
            )}
            <div className="personalInfoTitle">
              Personal information
            </div>
            <p className="sectionDescription">
              Please enter your details to complete your booking.
            </p>
            <PaymentInfoContainer>
              <FormInputField
                labelWeight='400'
                isRequired={true}
                placeholder="Full Name"
                inputFontSize = "14px"
                placeholderColor={colors.noBookingText}
                placeholderFontSize="14px"
                error={paymentError.cardHolderNameError}
                errorMessage={fieldErrorMessages.HOLDER_NAME || 'Please enter a valid full name'}
                borderColor={colors.signInBorderColor}
                className='paymentFormInput'
                onChange={(e) => {
                  onChangeCardHolderName(e)
                  if (paymentError.cardHolderNameError) {
                    setPaymentError((paymentError) => ({ ...paymentError, cardHolderNameError: false }))
                  }
                }}
                onBlur={(e) => {
                  if (e.target.value.length < 3) {
                    setPaymentError((paymentError) => ({ ...paymentError, cardHolderNameError: true }))
                  } else {
                    setPaymentError((paymentError) => ({ ...paymentError, cardHolderNameError: false }))
                  }
                }}
                value={paymentInfo.cardHolderName}
                inputHeight="50px"
              />

              <FormInputField
                className='emailInput paymentFormInput'
                placeholderColor={colors.noBookingText}
                placeholderFontSize="14px"
                inputFontSize = "14px"
                labelWeight='400'
                isRequired={true}
                error={emailError}
                placeholder='Email address'
                errorMessage={errorMessage}
                type="email"
                disabled={!!validToken}
                borderColor={colors.signInBorderColor}

                onChange={(e) => {
                  onChangeEmail(e)
                  if (emailError) {
                    setEmailError(false)
                  }
                }}
                onBlur={(e) => {
                  if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(e.target.value)) {
                    setEmailError(true)
                    setErrorMessage('Please enter a valid email address and try again.')
                  } else {
                    setEmailError(false)
                  }
                }}
                value={userInfo.emailInput}
                inputHeight="50px"
              />
              <Modal open={openSignInModal} >
                <SignInModalBody
                  setOpenSignInModal={setOpenSignInModal}
                  emailInput={userInfo.emailInput}
                />
              </Modal>
              <PhoneNumberInput
                placeholderColor={colors.noBookingText}
                placeholderFontSize="14px"
                key={`${userInfo.userId || 'guest'}-${initialPhoneNumber}`}
                initialValue={initialPhoneNumber}
                className='phoneNumberInput paymentFormInput'
                inputFontSize = "14px"
                //label="PHONE"
                labelWeight='400'
                isRequired={true}
                labelPosition='left'
                placeholder='Phone'
                iconUrl={nounQuestion}
                iconHint={{
                  title: 'Phone',
                  content: 'Enter a number we can use to contact you about your booking. Include your country code.',
                }}
                error={!phoneNumberValidity && phoneNumberError}
                errorMessage='Please enter a valid phone number'
                inputHeight="50px"
                marginBottom={'20px'}
                onChangeNumber={setPhoneNumber}
                setPhoneNumberValidity={setPhoneNumberValidity}
                onBlur={() => {
                  if (!phoneNumberValidity && (phoneNumber.length < 3)) {
                    setPhoneNumberError(true)
                  }
                }}
              />
              <FormInputField
                // label="BILLING ADDRESS"
                inputFontSize = "14px"
                labelWeight='400'
                isRequired={true}
                placeholderColor={colors.noBookingText}
                placeholderFontSize="14px"
                //                value={paymentInfo.billingAddress}
                value={paymentInfo.streetAddress}
                borderColor={colors.signInBorderColor}
                onChange={handleStreetAddressChange}
                error={
                  !!fieldErrorMessages.ADDRESS ||
                  !!fieldErrorMessages.STREET_ADDRESS
                }
                placeholder='Address (start entering location)'
                errorMessage={
                  fieldErrorMessages.ADDRESS ||
                  fieldErrorMessages.STREET_ADDRESS ||
                  'Please enter a street address'
                }
                // onChange={handleStreetAddressChange}
                // onChange={(e) => {
                //   setPaymentInfo((paymentInfo) => ({...paymentInfo, fullAddress: e.target.value}))
                //   if(paymentError.billingAddressError) {
                //     setPaymentError((paymentError) => ({...paymentError, billingAddressError: false}))
                //   }
                // }}
                onBlur={(e) => {
                  setFieldErrorMessages((prev) => ({
                    ...prev,
                    STREET_ADDRESS:
                      validateBillingAddressField(
                        'streetAddress',
                        e.target.value
                      ),
                  }));
                }}
                inputHeight="50px"
                className="paymentFormInput"
                iconUrl={nounSearch}
                iconHint={{
                  title: 'Address',
                  content: 'Start typing your address and select a suggestion from the list.',
                }}
                iconWidth={16}
                iconHeight={16}
                iconTop={17}
                inputRef={autocompleteRef}
              />
              <FormInputField
                placeholderColor={colors.noBookingText}
                placeholderFontSize="14px"
                inputFontSize = "14px"
                className="paymentFormInput"
                placeholder='Apartment, suite, etc. (optional)'
                labelWeight="400"
                borderColor={colors.signInBorderColor}
                value={addressLine2}
                onChange={(e) => setAddressLine2(e.target.value)}
                inputHeight="50px"
              />
              <CountryProvinceFields
                placeholderColor={colors.borderGrey3}
                placeholderFontSize="14px"
                inputFontSize = "14px"
                idPrefix="checkout-country"
                countryValue={paymentInfo.country || ''}
                provinceValue={paymentInfo.province || ''}
                onCountryChange={handleCountryChange}
                onProvinceChange={handleProvinceChange}
                showProvinceField={false}
                countryLabel=""
                countryPlaceholder="Start entering country"
                inputClassName="paymentFormInput"
                labelWeight="400"
                countryInnerLabel="Country/Region"
                countryError={!!fieldErrorMessages.COUNTRY}
                countryErrorMessage={
                  fieldErrorMessages.COUNTRY ||
                  'Please enter a country'
                }
                onCountryBlur={(e) => {
                  const value = e.target.value;

                  setFieldErrorMessages((prev) => ({
                    ...prev,
                    COUNTRY: validateBillingAddressField(
                      'country',
                      value
                    ),
                  }));
                }}
              />
              <div className="addressRow">

                <CountryProvinceFields
                  placeholderColor={colors.borderGrey3}
                  placeholderFontSize="14px"
                  inputFontSize = "14px"
                  idPrefix="checkout-province"
                  countryValue={paymentInfo.country || ''}
                  provinceValue={paymentInfo.province || ''}
                  onCountryChange={handleCountryChange}
                  onProvinceChange={handleProvinceChange}
                  showCountryField={false}
                  provinceLabel=""
                  provinceInnerLabel="Province/State"
                  provincePlaceholder="Start entering province"
                  inputClassName="paymentFormInput"
                  labelWeight="400"
                  marginBottom="0px"
                  provinceError={!!fieldErrorMessages.PROVINCE}
                  provinceErrorMessage={
                    fieldErrorMessages.PROVINCE ||
                    'Please enter a province/state'
                  }
                  onProvinceBlur={(e) => {
                    const value = e.target.value;

                    setFieldErrorMessages((prev) => ({
                      ...prev,
                      PROVINCE: validateBillingAddressField(
                        'province',
                        value
                      ),
                    }));
                  }}
                />
                <FormInputField
                  placeholderColor={colors.noBookingText}
                  placeholderFontSize="14px"
                  inputFontSize = "14px"
                  className="paymentFormInput"
                  labelWeight="400"
                  isRequired={true}
                  placeholder="City"
                  borderColor={colors.signInBorderColor}
                  value={paymentInfo.city || ''}
                  error={!!fieldErrorMessages.CITY}
                  errorMessage={
                    fieldErrorMessages.CITY ||
                    'Please enter a city'
                  }
                  onChange={(e) => {
                    clearFieldErrorMessage('CITY');

                    setPaymentInfo((prev) => ({
                      ...prev,
                      city: e.target.value,
                    }));
                  }}
                  onBlur={(e) => {
                    setFieldErrorMessages((prev) => ({
                      ...prev,
                      CITY: validateBillingAddressField(
                        'city',
                        e.target.value
                      ),
                    }));
                  }}
                  inputHeight="50px"
                />
                <FormInputField
                  placeholderColor={colors.noBookingText}
                  placeholderFontSize="14px"
                  inputFontSize = "14px"
                  className="paymentFormInput"
                  labelWeight="400"
                  isRequired={true}
                  placeholder="Postal Code"
                  borderColor={colors.signInBorderColor}
                  value={paymentInfo.postalCode || ''}
                  error={
                    !!fieldErrorMessages.ZIPCODE ||
                    !!fieldErrorMessages.POSTAL_CODE
                  }
                  errorMessage={
                    fieldErrorMessages.ZIPCODE ||
                    fieldErrorMessages.POSTAL_CODE ||
                    'Please enter a postal code'
                  }
                  onChange={(e) => {
                    clearFieldErrorMessage('ZIPCODE');
                    clearFieldErrorMessage('POSTAL_CODE');

                    setPaymentInfo((prev) => ({
                      ...prev,
                      postalCode: e.target.value,
                    }));
                  }}
                  onBlur={(e) => {
                    setFieldErrorMessages((prev) => ({
                      ...prev,
                      ZIPCODE: validateBillingAddressField(
                        'postalCode',
                        e.target.value
                      ),
                      POSTAL_CODE: '',
                    }));
                  }}
                  inputHeight="50px"
                />
              </div>

            </PaymentInfoContainer>

            <PaymentInfoContainer>
              <div className="paymentDetailsTitle">
                Your payment details
              </div>
              <p className="sectionDescription">
                Your payment information is secure and encrypted.
              </p>
              <div className="cardNumberBox">

                <ReactInputMask
                  mask={creditCardMask.mask}
                  maskPlaceholder=''
                  onChange={onChangeCreditCard}
                  onBlur={(e) => {
                    const digits = e.target.value.replace(/\D/g, '')
                    const invalid = isAmexCardNumber(digits)
                      ? detectCardType(digits) !== 'amex'
                      : digits.length < 16
                    if (invalid) {
                      setPaymentError((paymentError) => ({ ...paymentError, creditCardNumberError: true }))
                    } else {
                      setPaymentError((paymentError) => ({ ...paymentError, creditCardNumberError: false }))
                    }
                  }}
                  value={paymentInfo.creditCardNumber}
                >
                  <FormInputField
                    placeholderColor={colors.noBookingText}
                    placeholderFontSize="14px"
                    inputFontSize="14px"
                    className='creditCardInput paymentFormInput'
                    inputRef={inputRefs[0]}
                    labelWeight='400'
                    isRequired={true}
                    placeholder="Card number"
                    //                    maxLength={19}
                    error={!!fieldErrorMessages.CARD_NUMBER || paymentError.creditCardNumberError}
                    errorMessage={fieldErrorMessages.CARD_NUMBER || 'Please enter a valid credit card number'}
                    borderColor={colors.signInBorderColor}
                    inputHeight="50px"
                    iconUrl={creditCardType && !fieldErrorMessages.CARD_NUMBER ? greenCheck : lockLocked}
                    iconHint={{
                      title: 'Card Number',
                      content: 'Your payment details are secure.',
                    }}
                    iconWidth={creditCardType && !fieldErrorMessages.CARD_NUMBER ? 20 : 16}
                    iconHeight={creditCardType && !fieldErrorMessages.CARD_NUMBER ? 20 : 16}
                    iconTop={creditCardType && !fieldErrorMessages.CARD_NUMBER ? 15 : 17}
                  />
                </ReactInputMask>
                <div className="cvvExpiryBox">
                  <ReactInputMask
                    mask={expireDateMask.mask}
                    maskPlaceholder=''
                    onChange={(e) => {
                      onChangeExpireDate(e)
                      if (paymentError.cardExpirationDateError) {
                        setPaymentError((paymentError) => ({ ...paymentError, cardExpirationDateError: false }))
                      }
                    }}
                    onBlur={(e) => {
                      if (e.target.value.length < 5) {
                        setPaymentError((paymentError) => ({ ...paymentError, cardExpirationDateError: true }))
                      } else {
                        setPaymentError((paymentError) => ({ ...paymentError, cardExpirationDateError: false }))
                      }
                    }}
                    value={paymentInfo.cardExpirationDate}>
                    <FormInputField
                      placeholderColor={colors.noBookingText}
                      placeholderFontSize="14px"
                      inputFontSize="14px"
                      className='expireDateInput paymentFormInput'
                      inputRef={inputRefs[1]}
                      labelWeight='400'
                      isRequired={true}
                      placeholder="Expiration Date (MM / YY)"
                      error={paymentError.cardExpirationDateError}
                      errorMessage={fieldErrorMessages.EXPIRY || 'Please enter a valid expiry date'}
                      borderColor={colors.signInBorderColor}
                      inputHeight="50px"
                    />
                  </ReactInputMask>
                  <ReactInputMask
                    mask={isAmex ? amexCvvMask.mask : cvvMask.mask}
                    maskPlaceholder=''
                    onChange={onChangeCVV}
                    onBlur={(e) => {
                      cvvTouchedRef.current = true
                      if (!new RegExp('^[0-9]{' + cvvLength + '}$').test(e.target.value)) {
                        setPaymentError((paymentError) => ({ ...paymentError, cardCVVError: true }))
                      } else {
                        setPaymentError((paymentError) => ({ ...paymentError, cardCVVError: false }))
                      }
                    }}
                    value={paymentInfo.cardCVV}>
                    <FormInputField
                      placeholderColor={colors.noBookingText}
                      placeholderFontSize="14px"
                      inputFontSize="14px"
                      className='cvvInput paymentFormInput'
                      labelWeight='400'
                      inputRef={inputRefs[2]}
                      isRequired={true}
                      placeholder="Security Code"
                      error={paymentError.cardCVVError}
                      errorMessage={fieldErrorMessages.CVV || 'Please enter a valid CVV'}
                      borderColor={colors.signInBorderColor}
                      inputHeight="50px"
                      iconUrl={nounQuestion}
                      iconHint={{
                        title: 'Security Code',
                        content: 'Enter the 3-digit code on the back of your card, or the 4-digit code on the front for American Express.',
                      }}
                      iconWidth={16}
                      iconHeight={16}
                      iconTop={17}
                    />
                  </ReactInputMask>
                </div>
              </div>

              {/* {debugString} */}

            </PaymentInfoContainer>

            <div className="confirmSection">
              {showIUnderstandCheckbox && <NoWindowDisclaimerBlock />}
              <TermsOfServiceBlock />

              {windowWidth > parseInt(styleSizes.miniBreakpoint, 10) && (
                <div className="confirmButtonWrapper">
                  <StyledButton
                    className="checkOutButton"
                    width="156px"
                    height="48px"
                    fontSize={16}
                    disabled={loading}
                    loading={loading}
                    onClick={handleCheckOut}
                  >
                    {loading ? '' : 'Confirm & Book'}
                  </StyledButton>
                </div>
              )}
            </div>


            {windowWidth <= parseInt(styleSizes.miniBreakpoint, 10) && (
              <CouponInputBlock />
            )}


          </PaymentSectionContainer>
          {!isTabletLayout && (
            <BookingSummary
              handleCheckOut={handleCheckOut}
              loading={loading}
            />
          )}
          {/* <MobileBookingSummary handleCheckOut={handleCheckOut} /> */}



        </div>
      </div>

    </CheckOutContentContainer>
  )
}

export default CheckOutContent;
